<template>
    <div class="story-text">
        <div
            v-for="(paragraph, i) in paragraphs"
            :key="i"
            class="story-paragraph"
        >
            <span
                v-for="(span, j) in paragraph"
                :key="j"
                :class="{placeholder: placeholders[span]}"
            >
                {{ placeholders[span] ? placeholders[span] : span }}
            </span>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    props: {
        storyContent: {
            type: [String, Array],
            default: ''
        },
        placeholders: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        paragraphs() {
            const splitAroundSubstring = substr => str => str.split(substr).flatMap(s => [s, substr]).slice(0, -1).filter(s => s.length > 0);
            const splitFunctions = _(this.placeholders).keys().map(splitAroundSubstring).value();

            const paragraphs = typeof this.storyContent === 'string' ? [this.storyContent] : this.storyContent;
            return paragraphs
                .map(paragraph => splitFunctions.reduce((arr, func) => arr.flatMap(func), [paragraph]));
        }
    }
};
</script>

<style lang="postcss" scoped>

.story-text {
    @apply text-neutral-text font-normal leading-normal mb-6;
    max-width: 500px;
}

.story-paragraph:not(:first-of-type) {
    @apply mt-4;
}

.story-content > .dh-button {
    width: 250px;
}

.placeholder {
    @apply text-primary-4 font-bold;
}

/* @screen sm { */
    .story-text { font-size: 15px; }
/* } */
@screen md {
    .story-text { @apply text-sm; }
}
</style>
